import { Injectable } from '@angular/core'
import { CmsConverterService } from '../../../cms/services/cms-converter/cms-converter.service'
import { CmsComponent } from '@spartacus/core'
import { TrainingLocationsComponentData } from './index'

@Injectable({ providedIn: 'root' })
export class TrainingLocationsConverter extends CmsConverterService<TrainingLocationsComponentData> {

  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      trainingId: formData.st_training_id?.value,
    }
  }
}
